import { PublicKey, TransactionInstruction } from "@solana/web3.js";
import { ReferralProgram } from "../type";

export interface ITransferOwnerParams {
  referralProgram: ReferralProgram;
  stakingAddress: PublicKey;
  owner: PublicKey;
  newOwner: PublicKey;
}

export async function createTransferOwnerIx(
  params: ITransferOwnerParams,
): Promise<TransactionInstruction> {
  const { referralProgram, stakingAddress, owner, newOwner } = params;

  return referralProgram.methods
    .transferOwner()
    .accountsPartial({
      staking: stakingAddress,
      owner,
      newOwner,
    })
    .instruction();
}
